// Youssef Selkani
// 2019

import React, { Component } from 'react'
import fire from '../firebase'
import '../App.css'
import {
  Button,
  Header,
  Form,
  Modal,
  Icon,
} from 'semantic-ui-react'
import { withRouter } from 'react-router-dom'
import firebase from 'firebase/app'

class Account extends Component {
  constructor (props) {
    super(props)
    this.state = {
      loading: true,
      email: '',
      password: ''
    }
  }

  componentDidMount = () => {
    fire.auth().onAuthStateChanged(user => {
      if (user) {
        this.setState({ loggedIn: true, loading: false })
      } else {
        this.setState({ loggedIn: false, loading: false })
      }
    })
  }

  // Form Handler
  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value })
  }
  // Error Handler
  loginError = () => this.setState({ loginError: false })
  signupError = () => this.setState({ signupError: false })

  login = e => {
    const self = this
    self.setState({ loading: true })
    e.preventDefault()
    let { email, password } = this.state
    fire
      .auth()
      .setPersistence(firebase.auth.Auth.Persistence.SESSION)
      .then(function () {
        fire
          .auth()
          .signInWithEmailAndPassword(email, password)
          .then(u => {
            self.setState({ loading: false, })
            // self.props.history.push('/build')
          })
          .catch(function (error) {
            self.setState({ loginError: error.message, loading: false })
            console.log(error)
          })
      })
  }

  signup = () => {
    const { email, password } = this.state
    this.setState({ loading: true })
    fire
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then(u => {
        if (u.user) {
          const { currentUser } = fire.auth()
          let userUnderscore = currentUser.email.replace(/\./g, '_')
          fire
            .database()
            .ref(`master/users/${userUnderscore}/setup/`)
            .update({
              free: true,
              upload: null,
              appname: 'App',
              description: 'A cool description',
              icon: 'https://monosfer.com/images/coming-soon3.png',
              accent: '#000',
              url: 'https://yourdomain.com'
            })
            .then(() => {
              this.setState({ loading: false, loggedIn: true })
              this.props.history.push('/build')
            })
        }
      })
      .catch(error => {
        console.log(error)
        this.setState({ loading: false, signupError: error.message })
      })
  }

  render () {
    let { loginError, signupError, loggedIn, loading } = this.state
    return (
      <div className='div1'>
        <div className='overview centerX'>
          <div>
            <center>
              {!this.state.loading ? (
                <Icon name='lock' />
              ) : (
                <Icon color='black' name='circle notch' size='large' loading />
              )}
            </center>
            {!loggedIn && !loading ? (
              <Form>
                <div className='div3'>
                  <br />
                  <Form.Input
                    type='text'
                    onChange={this.handleChange}
                    placeholder='Email'
                    name='email'
                    autoComplete='username'
                  />
                  <Form.Input
                    type='password'
                    onChange={this.handleChange}
                    placeholder='Password'
                    name='password'
                    autoComplete='current-password'
                  />
                  <br />
                  <Button onClick={this.login} basic color='black'>
                    Log in
                  </Button>
                  <Button
                    onClick={this.signup}
                    style={{ backgroundColor: '#2E4C8F', color: '#fff' }}
                  >
                    Sign up
                  </Button>
                  <br />
                  <br />
                  <p>
                    By signing up, you are indicating that you have read and
                    agree to the <a href='/terms'> Terms of Service </a>and <a href='/privacy'> Privacy Policy</a>.
                  </p>
                </div>
              </Form>
            ) : null }
          </div>
        </div>

        <Modal
          basic
          onClose={this.loginError}
          size='small'
          open={this.state.loginError}
          centered={false}
        >
          <Header
            icon='key'
            style={{ color: '#fff', backgroundColor: '#F55E64' }}
            content={loginError}
          />
        </Modal>
        <Modal
          basic
          onClose={this.signupError}
          size='small'
          open={this.state.signupError}
          centered={false}
          dimmer
        >
          <Header icon='mail' content={signupError} />
        </Modal>
      </div>
    )
  }
}

export default withRouter(Account)
